import React, { useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";
import { deleteWorkoutPlanById, getExerciseData, uploadWorkout } from "../../api/workout/uploadJson";
import UpdateWorkoutTagTable from "./UpdateWorkoutTagTable";
import {
  updatePlanTagById,
  updateRecipieTagById,
  updateSinglePlanTagById,
} from "../../api/updateTag";
import { deleteSingleWorkoutById, getAllSingleWorkOut, uploadSingleWorkout } from "../../api/singleWorkout";
import UpdateRecipeTagTable from "./UpdateRecipeTagTable";
import { deleteRecipeDataById, getAllRecipeData, uploadRecipeData } from "../../api/recipe/uploadRecipe";
import { PERPAGE_RECORD } from "../../utils/isValidImage";

const UpdateAllWorkoutTag = () => {
  const [plans, setPlans] = useState([]);
  const [error, setError] = useState(null);
  const [selectedTags] = useState({});
  const [activeTab, setActiveTab] = useState("allWorkouts");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = PERPAGE_RECORD;

  const fetchPlans = useCallback(async () => {
    try {
      let data;
      if (activeTab === "allWorkouts") {
        data = await getExerciseData();
      } else if (activeTab === "singleWorkout") {
        data = await getAllSingleWorkOut();
      } else if (activeTab === "recipe") {
        data = await getAllRecipeData();
        data["data"] = data.recipes;
      }
      setPlans(data?.data || []);
      setCurrentPage(1);
    } catch (error) {
      setError("Failed to fetch plans");
      toast.error("Failed to fetch plans. Please try again.");
      console.error(error);
    }
  }, [activeTab]);
  useEffect(() => {
    fetchPlans().then();
  }, [activeTab, fetchPlans]);

  const convertTimestamp = (createdAtSeconds) => {
    const uploadDate = new Date(createdAtSeconds * 1000);
    return uploadDate.toLocaleDateString();
  };

  // Pagination Logic
  const totalPages = Math.ceil(plans.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedPlans = plans.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <div className="right-side-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 d-flex justify-content-between">
            <h4>
              {activeTab === "allWorkouts"
                ? "All Workout Details"
                : activeTab === "singleWorkout"
                  ? "Single Workout Details"
                  : "Recipe Details"}
            </h4>
            <ul className="nav nav-tabs mb-3" style={{ border: "none" }}>
              <li className="nav-item">
                <button
                  className={`nav-link  ${
                    activeTab === "allWorkouts" ? "active border-0" : "border-0"
                  }`}
                  onClick={() => setActiveTab("allWorkouts")}
                >
                  All Workouts
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${
                    activeTab === "singleWorkout"
                      ? "active border-0"
                      : "border-0"
                  }`}
                  onClick={() => setActiveTab("singleWorkout")}
                >
                  Single Workout
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${
                    activeTab === "recipe" ? "active border-0" : "border-0"
                  }`}
                  onClick={() => setActiveTab("recipe")}
                >
                  Recipes
                </button>
              </li>
            </ul>
          </div>

          {activeTab === "allWorkouts" && (
            <UpdateWorkoutTagTable
              header={[
                { label: "Workout Details", width: "40%" },
                { label: "Uploaded on", width: "25%" },
                { label: "Status", width: "15%" },
                { label: "Update Tag", width: "15%" },
              ]}
              plans={paginatedPlans}
              error={error}
              convertTimestamp={convertTimestamp}
              handleStatusUpdate={updatePlanTagById}
              selectedTags={selectedTags}
              handletoggleStatusUpdate={uploadWorkout}
              fetchPlans={fetchPlans}
              handleDelete={deleteWorkoutPlanById}
            />
          )}

          {activeTab === "singleWorkout" && (
            <UpdateWorkoutTagTable
              header={[
                { label: "Workout Details", width: "40%" },
                { label: "Uploaded on", width: "25%" },
                { label: "Status", width: "15%" },
                { label: "Update Tag", width: "15%" },
              ]}
              plans={paginatedPlans}
              error={error}
              convertTimestamp={convertTimestamp}
              handleStatusUpdate={updateSinglePlanTagById}
              selectedTags={selectedTags}
              handletoggleStatusUpdate={uploadSingleWorkout}
              fetchPlans={fetchPlans}
              handleDelete={deleteSingleWorkoutById}
            />
          )}

          {activeTab === "recipe" && (
            <UpdateRecipeTagTable
              header={[
                { label: "Recipe Details", width: "40%" },
                { label: "Uploaded on", width: "25%" },
                { label: "Status", width: "15%" },
                { label: "Update Tag", width: "15%" },
              ]}
              plans={paginatedPlans}
              error={error}
              convertTimestamp={convertTimestamp}
              handleStatusUpdate={updateRecipieTagById}
              selectedTags={selectedTags}
              handleToggleStatusUpdate={uploadRecipeData}
              fetchPlans={fetchPlans}
              handleDelete={deleteRecipeDataById}
            />
          )}
        </div>

        {/* Pagination */}
        {totalPages >= 1 && (
          <nav className="mt-3">
            <ul className="pagination justify-content-center">
              {/* Previous Button */}
              <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>
                  &laquo;
                </button>
              </li>

              {/* Page Numbers */}
              {[...Array(totalPages)].map((_, i) => {
                const pageNumber = i + 1;
                return (
                  (pageNumber <= 2 || pageNumber >= totalPages - 1 || (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)) && (
                    <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? "active" : ""}`}>
                      <button className="page-link" onClick={() => handlePageChange(pageNumber)}>
                        {pageNumber}
                      </button>
                    </li>
                  )
                );
              })}

              {/* Next Button */}
              <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>
                  &raquo;
                </button>
              </li>
            </ul>
          </nav>
        )}
      </div>
    </div>
  );
};

export default UpdateAllWorkoutTag;
